import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dPromotions$dTypes$dPromotionalItem from "../Restaumatic.Promotions.Types.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const elem = /* #__PURE__ */ (() => {
  const any1 = Data$dSet.foldableSet.foldMap((() => {
    const semigroupDisj1 = {append: v => v1 => v || v1};
    return {mempty: false, Semigroup0: () => semigroupDisj1};
  })());
  return x => any1(y => Restaumatic$dCart$dProductKey.eqProductKey.eq(x.product)(y.product) && x.productSeq === y.productSeq);
})();
const sequence = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Data$dMaybe.applicativeMaybe)(Data$dTraversable.identity))();
const assignmentIsSymbol = {reflectSymbol: () => "assignment"};
const inputIsSymbol = {reflectSymbol: () => "input"};
const promotionIdIsSymbol = {reflectSymbol: () => "promotionId"};
const selectionIsSymbol = {reflectSymbol: () => "selection"};
const sourceIsSymbol = {reflectSymbol: () => "source"};
const StoredPromotionalItemIsSymbol = {reflectSymbol: () => "StoredPromotionalItem"};
const encodeProductItemKey = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dCart$dProductItem.encodeProductItemKey(Restaumatic$dCart$dProductKey.encodeProductKey)({
  encodeWithOptions: v => Restaumatic$dCart$dProductKey.encodeProductKey.encode
});
const decodeProductItemKey = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dCart$dProductItem.decodeProductItemKey(Restaumatic$dCart$dProductKey.decodeProductKey)({
  decodeWithOptions: v => Restaumatic$dCart$dProductKey.decodeProductKey.decode
});
const StoredPromotionalItem = x => x;
const storeItem = v => ({promotionId: v.promotion.promotionId, selection: v.selection, assignment: v.assignment, source: v.source, input: v.input});
const storePromotionalItems = /* #__PURE__ */ Data$dFunctor.arrayMap(storeItem);
const isValidAssignment = v => v1 => {
  if (v.tag === "TargetCart") { return v1.tag === "UnassignmentToCart" || v1.tag === "AssignmentToCart"; }
  if (v.tag === "TargetProductItems") {
    if (v1.tag === "UnassignmentToProduct") { return true; }
    if (v1.tag === "AssignmentToProduct") { return elem(v1._1)(v._1); }
    return false;
  }
  return false;
};
const updateItem = v => v1 => {
  if (v.promotionId === v1.promotion.promotionId) {
    if (isValidAssignment(v1.target)(v.assignment)) {
      return Data$dMaybe.$Maybe("Just", {...v1, assignment: v.assignment, source: v.source, selection: v.selection, input: v.input});
    }
    return Data$dMaybe.Nothing;
  }
  return Data$dMaybe.Nothing;
};
const restorePromotionalItemAssignments = storedItems => engineItems => {
  if (storedItems.length === engineItems.length) { return sequence(Data$dArray.zipWithImpl(updateItem, storedItems, engineItems)); }
  return Data$dMaybe.Nothing;
};
const genericStoredPromotionalItem = {to: x => x, from: x => x};
const showStoredPromotionalItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItemSource(Restaumatic$dCart$dProductKey.showProductKey);
      const $1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItemAssignment(Restaumatic$dCart$dProductKey.showProductKey);
      return {
        genericShowArgs: v => [
          "{ assignment: " + $1.show(v.assignment) + ", input: " + Restaumatic$dPromotions$dTypes$dPromotionalItem.showPromotionalItemInput.show(v.input) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", selection: " + Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showSelectionStatus.show(v.selection) + ", source: " + $0.show(v.source) + " " + "}"
        ]
      };
    })())(StoredPromotionalItemIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const eqStoredPromotionalItem = {
  eq: /* #__PURE__ */ (() => {
    const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItemSource(Restaumatic$dCart$dProductKey.eqProductKey);
    const $1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItemAssignment(Restaumatic$dCart$dProductKey.eqProductKey);
    return x => y => $1.eq(x.assignment)(y.assignment) && (() => {
      if (x.input.tag === "FreeProductInput") {
        if (y.input.tag === "FreeProductInput") { return x.input._1.selection === y.input._1.selection; }
        return false;
      }
      if (x.input.tag === "NoInput") { return y.input.tag === "NoInput"; }
      return false;
    })() && x.promotionId === y.promotionId && Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqSelectionStatus.eq(x.selection)(y.selection) && $0.eq(x.source)(y.source);
  })()
};
const encodeStoredPromotionalItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericStoredPromotionalItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(StoredPromotionalItemIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(sourceIsSymbol)((() => {
      const encode1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.encodePromotionalItemSource(encodeProductItemKey).encode;
      return {encodeWithOptions: v => encode1};
    })()))(selectionIsSymbol)({encodeWithOptions: v => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.encodeSelectionStatus.encode}))(promotionIdIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(inputIsSymbol)({encodeWithOptions: v => Restaumatic$dPromotions$dTypes$dPromotionalItem.encodePromotionalItemInput.encode}))(assignmentIsSymbol)((() => {
      const encode1 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.encodePromotionalItemAssignment(encodeProductItemKey).encode;
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeStoredPromotionalItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericStoredPromotionalItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(StoredPromotionalItemIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(sourceIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.decodePromotionalItemSource(decodeProductItemKey).decode;
    return {decodeWithOptions: v => decode2};
  })())())(selectionIsSymbol)({decodeWithOptions: v => Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.decodeSelectionStatus.decode})())(promotionIdIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())(inputIsSymbol)({decodeWithOptions: v => Restaumatic$dPromotions$dTypes$dPromotionalItem.decodePromotionalItemInput.decode})())(assignmentIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.decodePromotionalItemAssignment(decodeProductItemKey).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  StoredPromotionalItem,
  StoredPromotionalItemIsSymbol,
  assignmentIsSymbol,
  decodeProductItemKey,
  decodeStoredPromotionalItem,
  elem,
  encodeProductItemKey,
  encodeStoredPromotionalItem,
  eqStoredPromotionalItem,
  genericStoredPromotionalItem,
  inputIsSymbol,
  isValidAssignment,
  promotionIdIsSymbol,
  restorePromotionalItemAssignments,
  selectionIsSymbol,
  sequence,
  showStoredPromotionalItem,
  sourceIsSymbol,
  storeItem,
  storePromotionalItems,
  updateItem
};
